"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCookieValue;

var _utils = require("@sm/utils");

var _getClientEnvironment = (0, _utils.getClientEnvironmentDetails)(),
    isBrowser = _getClientEnvironment.isBrowser;

function getCookieValue(cname, defaultValue) {
  if (!isBrowser) return '';
  var name = "".concat(cname, "=");
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return defaultValue || '';
}

module.exports = exports.default;